<template>
    <div class="topbar-container">
        <div class="line"></div>
        <div class="bv bc">
            <div class="img-logo bg-contain"></div>
            <div class="c_333 fz_70 text">
                <span class="fz_70">{{integer}}.{{decimal}}</span>
                <!-- <span class="fz_40">{{decimal}}</span> -->
            </div>
            <div class="c_666 fz_34">车主币余额</div>
            <div class="bh bc footBar">
                <van-button @click="go('MoneyExchange')" class="btn btn-goodbuy">
                    <span class="fz_30 btn-span">提现</span>
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MoneyBalance",
    data() {
        return {
            // 转换为两位小数
            moneyNum: "",
            // 整数
            integer: "",
            // 小数
            decimal: ""
        };
    },
    computed: {
        unusedPoints() {
            return this.$store.getters.unusedPoints;
        }
    },
    watch: {
        unusedPoints: {
            handler(v) {
                const me = this;
                // 取小数部分
                me.decimal = v.substr(v.length - 2, 2);
                // 取整数部分
                me.integer = parseInt(v);
            },
            immediate: true
        }
    }
};
</script>

<style scoped lang="scss">
@include img-list("~@/assets/imges/money/", "logo");
.topbar-container {
    background-color: #fff;
    .line {
        background-color: #f1f2f3;
    }
    .img-logo {
        width: 116px;
        height: 116px;
        margin-top: 89px;
    }
    .text {
        padding: 49px 0 30px 0;
    }
    .footBar {
        margin-top: 89px;
        .btn-goodbuy {
            width: 510px;
            height: 76px;
        }
    }
}
</style>
